import SearchRequestUtils from 'search-request/search-request-utils';
import {initialState as searchRequestInitialState} from 'search-request/search-request-reducer';
import SearchUtils from 'search/search-utils';
import ExperimentUtils from 'utils/experiment';
import SearchAPI from 'api/search';

export const ROUTER_HISTORY_CALLED = 'ROUTER_HISTORY_CALLED';
export const ROUTER_DATA_LOAD_FULFILLED = 'ROUTER_DATA_LOAD_FULFILLED';

const updateLocation = method => (url, state = {}) => ({
    type: ROUTER_HISTORY_CALLED,
    payload: {
        method,
        url,
        state,
    },
});

export const push = updateLocation('push');
export const replace = updateLocation('replace');
export const pop = updateLocation('pop');
export const go = updateLocation('go');
export const goBack = updateLocation('goBack');
export const goForward = updateLocation('goForward');

export const dataLoadFulfilled = cleanedData => ({
    type: ROUTER_DATA_LOAD_FULFILLED,
    payload: cleanedData,
});

export async function createCleanedData({
    currentCity,
    cleanedParams,
    currentSearchState,
    checkoutState = {},
}) {
    const {
        page_info: {page_type: pageType, setup},
        rid,
    } = cleanedParams;
    const loadedData = await SearchRequestUtils.loadDataSequence({
        pageType,
        setup,
        isNewCity: setup.city.slug !== currentCity.data.slug,
    });
    const cleanedData = {
        searchRequest: SearchRequestUtils.sanitizeSearchRequestResponse({
            state: searchRequestInitialState,
            response: cleanedParams,
        }),
        checkout: {...checkoutState, rid},
        ...loadedData,
    };

    if (!cleanedData.city) {
        cleanedData.city = currentCity;
    }

    cleanedData.search = SearchUtils.prepareStoreData({
        initData: cleanedData,
        experimentUtils: ExperimentUtils,
        pageType,
        currentSearchState,
    });

    cleanedData.search.data.sid = cleanedParams.sid;

    return cleanedData;
}

export async function fetchCleanedData({state, route}) {
    const {city, search: searchState, checkout: checkoutState} = state;
    const {
        location: {pathname, search},
    } = route;
    const {
        data: {data: cleanedParams},
    } = await SearchAPI.cleanParams({url: `${pathname}${search || ''}`});

    return createCleanedData({
        currentCity: city,
        cleanedParams,
        currentSearchState: searchState,
        checkoutState,
    });
}
